import React from "react";
import { Modal, Button, Spin, Progress, Result } from "antd";

/**
 * Upload -> processing -> completed/failed status modal, cloned from
 * EmployeeInout.js's Attendance Import Progress Modal so every bulk-import
 * screen (WFH, On Duty, ...) gets the same UX for free via useBulkImport.
 */
const ImportProgressModal = ({
  title,
  visible,
  importStatus,
  importPolling,
  onClose,
  onCancelImport,
  onDownloadErrors,
}) => (
  <Modal
    title={title}
    open={visible}
    onCancel={() => {
      if (!importPolling) onClose();
    }}
    footer={
      importStatus && ["completed", "failed"].includes(importStatus.status)
        ? [
            importStatus?.errorFile?.generated && (
              <Button key="download-errors" onClick={onDownloadErrors}>
                Download Error Report ({importStatus.errorFile.errorCount} errors)
              </Button>
            ),
            <Button key="close" type="primary" onClick={onClose}>
              Close
            </Button>,
          ]
        : [
            <Button key="cancel-import" danger onClick={onCancelImport}>
              Cancel Import
            </Button>,
          ]
    }
    width={500}
  >
    {!importStatus || importStatus.status === "pending" ? (
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Spin size="large" />
        <p style={{ marginTop: 16, color: "#666" }}>Uploading and queuing import...</p>
      </div>
    ) : importStatus.status === "processing" ? (
      <div>
        <Progress percent={importStatus.progressPercentage || 0} status="active" />
        {(importStatus.progressPercentage || 0) >= 100 ? (
          <p style={{ marginTop: 8, color: "#666" }}>
            <Spin size="small" style={{ marginRight: 8 }} />
            Finalizing, please wait...
          </p>
        ) : (
          <p style={{ marginTop: 8, color: "#666" }}>
            Processed {importStatus.processedRecords || 0} of {importStatus.totalRecords || 0} records
          </p>
        )}
        {importStatus.failedRecords > 0 && (
          <p style={{ color: "#ff4d4f" }}>{importStatus.failedRecords} records failed</p>
        )}
      </div>
    ) : importStatus.status === "completed" ? (
      <Result
        status="success"
        title="Import Completed"
        subTitle={
          <div>
            <p>{importStatus.successfulRecords} records imported successfully</p>
            {importStatus.failedRecords > 0 && (
              <p style={{ color: "#ff4d4f" }}>{importStatus.failedRecords} records failed</p>
            )}
          </div>
        }
      />
    ) : importStatus.status === "failed" ? (
      <Result
        status="error"
        title="Import Failed"
        subTitle={importStatus.lastError || "An error occurred during import"}
      />
    ) : null}
  </Modal>
);

export default ImportProgressModal;
